import { handleActions } from 'redux-actions';
import { nodeWidgetCustomizationActions } from '../../actions/nodeWidgetCustomization';
export const { nodeWidgetCustomizationAddLocalization, nodeWidgetCustomizationRemoveLocalization, nodeWidgetCustomizationResetLocalization, nodeWidgetCustomizationLoadPayload, } = nodeWidgetCustomizationActions;
const allLocalizations = {
    'en-US': {
        minimized: {
            html_text_online: 'Need help? **We are online**',
            html_text_offline: 'Get in touch',
        },
    },
    'es-ES': {
        minimized: {
            html_text_online: 'Necesita ayuda? **Estamos en línea**',
            html_text_offline: 'Déjenos un comentario',
        },
    },
    'de-DE': {
        minimized: {
            html_text_online: 'Benötigen Sie Hilfe? **Wir sind online**',
            html_text_offline: 'Hinterlassen Sie uns eine Nachricht',
        },
    },
    'it-IT': {
        minimized: {
            html_text_online: 'Hai bisogno di aiuto? **Siamo online**',
            html_text_offline: 'Lasciaci un messaggio',
        },
    },
    'pl-PL': {
        minimized: {
            html_text_online: 'Potrzebujesz pomocy? **Jesteśmy online**',
            html_text_offline: 'Zostaw nam wiadomość',
        },
    },
    'pt-PT': {
        minimized: {
            html_text_online: 'Precisa de ajuda? **Estamos online**',
            html_text_offline: 'Deixe-nos uma mensagem',
        },
    },
    'fr-FR': {
        minimized: {
            html_text_online: 'Besoin d’aide? **Nous sommes en ligne**',
            html_text_offline: 'Laissez-nous un message',
        },
    },
    da: {
        minimized: {
            html_text_online: 'Har du brug for hjælp? **Vi er online**',
            html_text_offline: 'Skriv til os',
        },
    },
    no: {
        minimized: {
            html_text_online: 'Trenger du hjelp? ** Vi er her**',
            html_text_offline: 'Legg igjen en beskjed',
        },
    },
    sv: {
        minimized: {
            html_text_online: 'Behöver du hjälp? **Vi är online**',
            html_text_offline: 'Lämna ett meddelande',
        },
    },
    fi: {
        minimized: {
            html_text_online: 'Tarvitseko apua? **Olemme online tilassa**',
            html_text_offline: 'Jätä meille viesti',
        },
    },
    nl: {
        minimized: {
            html_text_online: 'Hulp nodig? **We zijn online** ',
            html_text_offline: 'Laat een bericht achter',
        },
    },
    'lt-LT': {
        minimized: {
            html_text_online: 'Reikia pagalbos? **Mes esame prisijungę** ',
            html_text_offline: 'Palikite mums žinutę',
        },
    },
    'lv-LV': {
        minimized: {
            html_text_online: 'Vajadzīga palīdzība? **Mēs esam tiešsaitē** ',
            html_text_offline: 'Atstājiet mums ziņu',
        },
    },
    'et-EE': {
        minimized: {
            html_text_online: 'Vajate abi? **Oleme võrgus**',
            html_text_offline: 'Jätke meile sõnum',
        },
    },
    'ru-RU': {
        minimized: {
            html_text_online: 'Нужна помощь? **Мы в сети**',
            html_text_offline: 'Оставьте нам сообщение',
        },
    },
    'hr-HR': {
        minimized: {
            html_text_online: 'Potrebna pomoć? **Vi ste uključeni**',
            html_text_offline: 'Ostavite nam poruku',
        },
    },
    'ro-RO': {
        minimized: {
            html_text_online: 'Aveti nevoie de ajutor?**Suntem online**',
            html_text_offline: 'Lasati un mesaj',
        },
    },
    'hu-HU': {
        minimized: {
            html_text_online: 'Segítségre van szüksége? **Mi online vagyunk**',
            html_text_offline: 'Hagyjon egy üzenetet',
        },
    },
    'el-GR': {
        minimized: {
            html_text_online: 'Χρειάζεστε βοήθεια; **Είμαστε συνδεδεμένοι**',
            html_text_offline: 'Αφήστε μας ένα μήνυμα ',
        },
    },
    'th-TH': {
        minimized: {
            html_text_online: 'ต้องการความช่วยเหลือ? **เราออนไลน์อยู่**',
            html_text_offline: 'ฝากข้อความถึงเรา F̄āk k̄ĥxkhwām t̄hụng reā',
        },
    },
    'vi-VN': {
        minimized: {
            html_text_online: 'Cần giúp đỡ? **Chúng tôi đang trực tuyến**',
            html_text_offline: 'Để lại cho chúng tôi một tin nhắn',
        },
    },
    'ko-KR': {
        minimized: {
            html_text_online: '도움이 필요하세요? **온라인상태입니다.**',
            html_text_offline: '메시지를 남겨주세요.',
        },
    },
    'id-ID': {
        minimized: {
            html_text_online: 'Butuh bantuan? **Kami sedang online**',
            html_text_offline: 'Tinggalkan pesan untuk kami',
        },
    },
    'ms-MY': {
        minimized: {
            html_text_online: 'Perlukan bantuan? **Kami sedang dalam talian**',
            html_text_offline: 'Tinggalkan kami mesej',
        },
    },
    'cs-CZ': {
        minimized: {
            html_text_online: 'Potřebujete pomoci? **Jsme online**',
            html_text_offline: 'Zanechte nám zprávu',
        },
    },
    'zh-CN': {
        minimized: {
            html_text_online: '需要帮忙？ **我们在线**',
            html_text_offline: '给我们留言',
        },
    },
    ar: {
        minimized: {
            html_text_online: 'هل تحتاج إلى مساعدة؟ **نحن هنا**',
            html_text_offline: 'اترك رسالة',
        },
    },
    'hi-IN': {
        minimized: {
            html_text_online: 'मदद चाहिए? **हम ऑनलाइन हैं**',
            html_text_offline: 'हमें एक संदेश दें',
        },
    },
    'ja-JP': {
        minimized: {
            html_text_online: 'サポートが必要ですか？ **オンライン中です**',
            html_text_offline: 'メッセージを入力してください',
        },
    },
    'tr-TR': {
        minimized: {
            html_text_online: 'Yardım ister misiniz? **Çevrim içiyiz**',
            html_text_offline: 'Bize bir mesaj bırakın',
        },
    },
    is: {
        minimized: {
            html_text_online: 'Þartu hjálp? **Við erum á netinu**',
            html_text_offline: 'Skrifaðu okkur',
        },
    },
};
function emptyLocalization(localization) {
    return allLocalizations[localization];
}
// Init state.
function initialState() {
    return {
        loaded: false,
        localizations: {
            'en-US': {
                minimized: {
                    html_text_online: 'Need help? **We are online**',
                    html_text_offline: 'Get in touch',
                },
            },
        },
        medium: {
            minimized_view: {
                position: 'bottom_right',
                view: 'sticky',
            },
            chatbox_view: {
                position: 'bottom_right',
            },
        },
        nextNodeId: '',
        small: {
            minimized_view: {
                position: 'bottom_right',
            },
            chatbox_view: {
                position: 'bottom_right',
            },
        },
        theme: {
            color: '#5e6776',
            color_darken: '#283044',
            color_lighten: '#8292b6',
            text_color: '#ffffff',
        },
    };
}
// Reducer
const nodeWidgetCustomization = handleActions({
    [nodeWidgetCustomizationAddLocalization.toString()]: (state, action) => {
        const { local } = action.payload;
        const localization = emptyLocalization(local);
        const localizations = Object.assign({}, state.localizations);
        localizations[local] = localization;
        return Object.assign(Object.assign({}, state), { localizations: localizations });
    },
    [nodeWidgetCustomizationRemoveLocalization.toString()]: (state, action) => {
        const { local } = action.payload;
        const localizations = Object.assign({}, state.localizations);
        delete localizations[local];
        return Object.assign(Object.assign({}, state), { localizations: localizations });
    },
    [nodeWidgetCustomizationResetLocalization.toString()]: (state) => {
        const localizations = {};
        const localization = emptyLocalization('en-US');
        localizations['en-US'] = localization;
        return Object.assign(Object.assign({}, state), { loaded: false, localizations: localizations });
    },
    [nodeWidgetCustomizationLoadPayload.toString()]: (state, action) => {
        const { node } = action.payload;
        if (node.payload !== null) {
            return Object.assign(Object.assign(Object.assign({}, state), node.payload), { loaded: true });
        }
        return state;
    },
}, initialState());
export default nodeWidgetCustomization;
